<gcc-urgent-alerts-slider (delete)="handleDelete($event)" [sliderData]="notifications$ | async">
</gcc-urgent-alerts-slider>
